import { useEkardoLazyQuery } from '@netfront/ekardo-content-library';
import { GET_USER_FLOW_STEP_QUERY } from './useGetUserFlowStep.graphql';
import type {
  IGetUserFlowStepQueryGraphQLResponse,
  IGetUserFlowStepQueryVariables,
  IHandleGetUserFlowStepParams,
  IUseGetUserFlowStep,
  IUseGetUserFlowStepOptions,
} from './useGetUserFlowStep.types';

export const useGetUserFlowStep = (options?: IUseGetUserFlowStepOptions): IUseGetUserFlowStep => {
  const { fetchPolicy, onCompleted, onError, product, query, tokens } = options ?? ({} as IUseGetUserFlowStepOptions);

  const [executeGetUserFlowSteps, { loading: isLoading }] = useEkardoLazyQuery<
    IGetUserFlowStepQueryGraphQLResponse,
    IGetUserFlowStepQueryVariables
  >({
    options: {
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          userFlowStep: { getUserFlowStep },
        } = data;

        onCompleted({
          userFlowStep: getUserFlowStep,
        });
      },
      onError,
    },
    product,
    query: query ?? GET_USER_FLOW_STEP_QUERY,
    tokens,
  });

  const handleGetUserFlowStep = async ({ userFlowStepId }: IHandleGetUserFlowStepParams) => {
    await executeGetUserFlowSteps({
      variables: {
        userFlowStepId
      },
    });
  };

  return {
    handleGetUserFlowStep,
    isLoading,
  };
};
